const SOLUTION_SUMMARIES: Record<string, string> = {
  '20981023-5d41-4109-b406-2b74970a2db3':
    'Given your agronomic preferences of a historical yield range of 10–13 t/ha, FAO maturity range 120–320, targeted planting date 09/04/26, and high importance for grain yield, under predominantly very hot and dry to hot and dry conditions, our expert seed advice is to plant SY Evident at a seed rate of approximately 73,000 seeds/ha. This hybrid is well-suited for your production goals in challenging climatic environments.',

  'adc611e0-2012-4cbf-adc0-bef92f5fef65':
    'Given your agronomic preferences of a historical yield range of 3–4 t/ha and targeted planting date 24/04/26 under predominantly hot and dry conditions, our expert seed advice is to plant Sureli at a seed rate of approximately 57,000 seeds/ha. This hybrid offers high linoleic acid content with Express® herbicide tolerance, consistent top performance in official trials, and reliably high oil content paired with strong yields, making it well-suited for your production goals.',
};

export const getSolutionSummary = (solutionId: string | undefined): string | undefined => {
  if (!solutionId) {
    return undefined;
  }
  return SOLUTION_SUMMARIES[solutionId];
};

export const stripLeadingHeading = (summary: string): string =>
  summary.replace(/^\s*#{1,6}[ \t]+[^\n]*(?:\r?\n|$)/, '').trim();
